import {
  between, double, integer, max, min_value as minValue, oneOf, required,
} from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('integer', {
  ...integer,
  message: 'This field must be an integer',
})

extend('double', {
  ...double,
  message: 'This field must be a float',
})

extend('max', {
  ...max,
  message: 'This field must be {length} characters or less',
})

extend('min_value', {
  ...minValue,
  message: 'This field must be at least {min}',
})

extend('between', {
  ...between,
  message: 'This field must be between {min} and {max}',
})

extend('oneOf', {
  ...oneOf,
  message: 'Invalid value',
})

extend('required', {
  ...required,
  message: 'Required',
})

extend('url', {
  validate: value => {
    try {
      const url = new URL(value)

      return url.pathname.length && (['http:', 'https:'].includes(url.protocol))
    } catch {
      return false
    }
  },
  message: 'Invalid url',
})

extend('k72url', {
  validate: value => {
    if (!value) return false
    try {
      const url = new URL(value)
      const allowedHosts = [
        'k72-storage-sta.b-cdn.net',
        'k72-storage-prod.b-cdn.net',
      ]

      return allowedHosts.includes(url.host) && url.protocol === 'https:'
    } catch {
      return false
    }
  },
  message: 'The URL must begin with https://k72-storage',
})

extend('imageFile', {
  validate: value => {
    try {
      return value.type.startsWith('image/')
    } catch {
      return false
    }
  },
  message: 'Not an image file',
})

extend('videoFile', {
  validate: value => {
    try {
      return value.type.startsWith('video/')
    } catch {
      return false
    }
  },
  message: 'Not a video file',
})

extend('arrayRequired', {
  validate: value => Array.isArray(value) && value.length > 0,
  message: 'This field is required',
})
